import { render, staticRenderFns } from "./TPSEdit.vue?vue&type=template&id=21d313e0&"
import script from "./TPSEdit.vue?vue&type=script&lang=js&"
export * from "./TPSEdit.vue?vue&type=script&lang=js&"
import style0 from "./TPSEdit.vue?vue&type=style&index=0&id=21d313e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports